import { RadioGroup, FormControlLabel, Radio, Box, Typography, MenuItem, Select, FormControl } from '@mui/material';
import { MixCodesDetails } from '../../../components/assignPromotionFlowComponent/MixCodesDetails';
import { useEffect, useState } from 'react';
import { PluginStoreDetails } from '../../../components/assignPromotionFlowComponent/PluginStoreDetails';
import { ChipComponent } from "../../../components/chipComponent/ChipComponent";
import { MixedcodesEnvironment } from '../../../types/componentTypes/mixcodes-types';
import { getCurrentMixedcodesEnvironment, isSwitchEnvironmentAllowed } from '../MixCodes/helpers/mixcodes-helper';
import { PromoMechanic } from '../../../types/componentTypes/editPromotion';

const ProofOfPurchaseDetails = ({ formik }) => {

    const [environment, setEnvironment] = useState<MixedcodesEnvironment>(getCurrentMixedcodesEnvironment(formik.values?.secrets?.mixCodesParameters[0]));
    const proofType = formik.values.proofType || 'none';
    const flowOption = formik.values.tempParams.promoFlow || formik.values.tempParams.flowOption;
    const isCollectAndGet =
        flowOption === PromoMechanic.CollectAndGet ||
        flowOption === PromoMechanic.AutoRedeemCnG ||
        flowOption === "redeemPincodeForCurrencies";
    const isEditPage = typeof formik.values?.tempParams?.promoFlow === 'string' && !!formik.values.tempParams.promoFlow;


    useEffect(() => {
        if (isCollectAndGet && proofType === 'none') {
        formik.setFieldValue('proofType', 'mixCodes');
        }
        // eslint-disable-next-line
    }, [isCollectAndGet]);

    function handleChange(e) {
        const newValue = e.target.value;
        if (proofType === 'receiptScanner' && newValue !== 'receiptScanner') {
            formik.setFieldValue('pluginParams', formik.initialValues.pluginParams);
        }
        formik.setFieldValue('proofType', newValue);
    }

    const handleEnvironmentChange = (e): void => {
        const env = e.target.value as MixedcodesEnvironment;
        setEnvironment(env);
    }

    return (
        <Box justifyContent={'center'}>
            <Typography variant="h3" gutterBottom> Proof of Purchase</Typography>
            <Typography variant="h6" gutterBottom> Select whether MiX Codes or receipts are required to participate in this promotion. </Typography>
        <Box display="flex" justifyContent="center" my={2}>
        <RadioGroup row value={proofType} onChange={handleChange}>
            <FormControlLabel
            value="none"
            control={<Radio />}
            label="N/A"
            disabled={isCollectAndGet}
            />
            <FormControlLabel value="mixCodes" control={<Radio />} label="MiX Codes" />
            <FormControlLabel value="receiptScanner" control={<Radio />} label="Receipt Scanner" />
        </RadioGroup>
        </Box>
        {proofType === 'none' && <Typography align='center'>No Proof of Purchase Validation Selected</Typography>}
        {proofType === 'mixCodes' && (
            <>
            {isSwitchEnvironmentAllowed() && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                    Environment:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                        value={environment}
                        onChange={handleEnvironmentChange}
                        sx={{ fontSize: '14px' }}
                        data-testid='gamma-environment-select'
                    >
                        <MenuItem value="Test">Test</MenuItem>
                        <MenuItem value="Production">Prod</MenuItem>
                    </Select>
                    </FormControl>
                    <ChipComponent
                        label={environment}
                        labelColorMap={{Production: 'error'}}
                        chipStyles={{width: 100}}
                        size='small'
                        dataTestId='gamma-environment-chip'
                    />
                </Box>
            )}
            <Typography align="center" sx={{ marginBottom: '15px' }}>
                MiX Codes Detail:
            </Typography>
            <Box sx={formik.values.tempParams.promoFlow ? { width: '340px' } : { width: '105%' }} justifyContent='center'>
                    <MixCodesDetails formik={formik} environment={environment} />
            </Box>
            </>
        )}
        {proofType === 'receiptScanner' && (
            <>
            <Typography align="center" sx={{ marginBottom: '15px' }}>
                Receipt Scanner Details:
            </Typography>
            <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <PluginStoreDetails formik={formik} isEditPage={isEditPage} />
            </Box>
            </>
        )}
        </Box>
    );
};

export default ProofOfPurchaseDetails;
